<template>
  <div>
    <div class="user-info">
      <div class="systemTypeBtns" v-if="isShowsystemTypeBtns">
        <a-select
          v-model="value"
          placeholder="请选择搜索条件"
          class="search-default-value"
          @change="changeSystem"
        >
          <a-select-option
            v-for="opt in SystemList"
            :key="opt.value"
            :value="opt.value"
            >{{ opt.label }}</a-select-option
          >
        </a-select>
      </div>
      <!-- 待办铃铛 -->
      <div class="todo-bell-wrapper">
        <el-popover placement="bottom" width="240" trigger="hover">
          <div class="todo-panel">
            <div class="todo-title">待办列表</div>
            <div class="todo-list">
              <div v-for="item in visibleTodoList" :key="item.type" class="todo-item">
                <div class="todo-left">
                  <span class="todo-name">{{ item.name }}</span>
                  <span v-if="item.count > 0" class="todo-count-badge">{{ item.count }}</span>
                </div>
                <a
                  href="javascript:void(0)"
                  class="todo-view"
                  @click="handleTodoView(item)"
                >查看</a>
              </div>
            </div>
          </div>
          <div slot="reference" class="bell-icon-wrapper">
            <el-badge :value="totalTodoCount" :hidden="totalTodoCount <= 0" class="todo-badge-item">
              <i class="el-icon-bell" style="font-size: 20px; color: #595959; cursor: pointer;"></i>
            </el-badge>
          </div>
        </el-popover>
      </div>
      <a-dropdown>
        <a @click="(e) => e.preventDefault()" class="user-info-link">
          <!-- <img src="../assets/images/user_img.png" class="head-img" /> -->
          <img :src="avatarImg" class="head-img" />
          <div class="user-meta">
            <span class="user-name">{{ this.$store.state.user.name }}</span>
            <a-tag
              color="blue"
              v-if="this.$store.state.user.user && this.$store.state.user.user.tenantName"
              class="tenant-tag"
            >{{ this.$store.state.user.user.tenantName }}</a-tag>
          </div>
        </a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a @click="changePwd()">修改密码</a>
          </a-menu-item>
          <a-menu-item>
            <a @click="doLogOut()">退出登录</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <div>
      <user-edit-pass
        :u_id="u_id"
        v-if="changePwdShow"
        @onClose="onClose"
      ></user-edit-pass>
    </div>
  </div>
</template>
<script>
import UserEditPass from "./UserEditPass";
import store from "../store";
import router from "../router";
import { GetConstructionOrderTodoCount } from "@/api/apiJF/material";
// import { resetRouter } from "../router";

import { DoLogout } from "@/api/login";
export default {
  name: "UserInfo",
  components: { UserEditPass },
  data() {
    return {
      name: this.$store.state.user.name,
      u_id: this.$store.state.user.id,
      changePwdShow: false,
      value: "xc",
      isShowsystemTypeBtns: false,
      avatarImg: this.$store.state.user.avatar,
      SystemList: [
        // { value: "xc", label: "现场管理系统" },
        // { value: "jf", label: "交付系统" },
        // { value: "yx", label: "营销系统" },
        // { value: "cw", label: "财务系统" },
      ],
      todoList: [
        { type: "construction", name: "施工项待办", count: 0, path: "" },
        { type: "package", name: "套餐待办", count: 0, path: "" },
        { type: "contract", name: "合同待办", count: 0, path: "" },
        { type: "quotation", name: "报价待办", count: 0, path: "" },
        { type: "order", name: "订单待办", count: 0, path: "/material/AlreadyOrder" },
      ],
    };
  },
  computed: {
    visibleTodoList() {
      return this.todoList.filter((item) => item.type === "order");
    },
    totalTodoCount() {
      return this.visibleTodoList.reduce((sum, item) => sum + item.count, 0);
    },
  },
  created() {
    setTimeout(() => {
      this.u_id = this.$store.state.user.id;
      // console.log("userinfo", this.$store.state.user.menus);
      // 现场管理菜单
      let roles = this.$store.state.user.menus.osmcore
        ? this.$store.state.user.menus.osmcore
        : [];
      // 交付系统菜单
      let rolesJF = this.$store.state.user.menus.dsmcore
        ? this.$store.state.user.menus.dsmcore
        : [];
      // 营销系统菜单
      let rolesYX = this.$store.state.user.menus.mkscore
        ? this.$store.state.user.menus.mkscore
        : [];
      if (roles && roles.length > 0) {
        this.SystemList.push({
          value: "xc",
          label: "现场管理系统",
        });
      }
      if (rolesJF && rolesJF.length > 0) {
        this.SystemList.push({
          value: "jf",
          label: "交付系统",
        });
      }
      if (rolesYX && rolesYX.length > 0) {
        this.SystemList.push({
          value: "yx",
          label: "营销系统",
        });
      }
      // 是否展示选择系统的选择框
      if (this.SystemList.length > 1) {
        this.isShowsystemTypeBtns = true;
      } else {
        this.isShowsystemTypeBtns = false;
      }

      // 查询待办数量
      this.fetchTodoCount();

      let SET_SYSTEMValue = localStorage.getItem("SET_SYSTEM");
      // 如果本地存储的有选择哪个系统
      if (SET_SYSTEMValue) {
        // console.log("SET_SYSTEMValue", SET_SYSTEMValue);
        this.$store.commit("SET_SYSTEM", SET_SYSTEMValue);
        this.value = SET_SYSTEMValue;
        // if (SET_SYSTEMValue == "xc") {
        //   this.isShowsystemTypeBtns = true;
        // } else {
        //   this.isShowsystemTypeBtns = true;
        // }
      } else {
        // if (rolesJF == "") {
        //   // this.isShowsystemTypeBtns = false;
        //   this.value = "xc";
        //   this.$store.commit("SET_SYSTEM", "xc");
        // } else {
        //   // this.isShowsystemTypeBtns = true;
        //   this.$store.commit("SET_SYSTEM", "jf");
        // }
        // 如果没有指定那个系统，则展示第一个系统
        this.value = this.SystemList[0].value;
        this.$store.commit("SET_SYSTEM", this.SystemList[0].value);
      }
    }, 100);
  },
  methods: {
    doLogOut() {
      DoLogout()
        .then((response) => {
          if (response.code == "200") {
            localStorage.removeItem("userMsg");
            this.$store.commit("SET_ROLES", "");
            this.$store.commit("SET_ROLESJF", "");
            sessionStorage.removeItem("token");
            this.$router.push({ path: "/login" });
            sessionStorage.removeItem("roles");

            localStorage.removeItem("path", "");
            localStorage.removeItem("SET_SYSTEM");
            this.$store.commit("SET_CURRENT", "");
            this.$store.commit("SET_SYSTEM", "");
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
      // localStorage.removeItem("userMsg");
      // this.$store.commit("SET_CURRENT", "");
    },
    onClose() {
      this.changePwdShow = false;
    },
    changePwd() {
      this.changePwdShow = true;
    },
    changeSystem(e) {
      let value = e;
      // console.log("选择现场管理系统或交付系统", value);
      this.$store.commit("SET_SYSTEM", value);
      localStorage.setItem("SET_SYSTEM", value);
      let menus = [];
      let that = this;
      if (value == "xc") {
        menus = this.$store.state.user.menus.osmcore;
      } else if (value == "jf") {
        menus = this.$store.state.user.menus.dsmcore;
      } else if (value == "yx") {
        menus = this.$store.state.user.menus.mkscore;
      }
      store.dispatch("GenerateRoutes", menus).then((accessRoutes) => {
        // resetRouter();
        // 根据 roles 权限生成可访问的路由表
        // console.log("accessRoutes", accessRoutes);
        router.addRoutes(accessRoutes); // 动态添加可访问路由表
        let lastRou = [{ path: "*", redirect: "/404", hidden: true }];
        router.addRoutes(lastRou);
        //如果是现场管理系统，默认跳转首页
        if(value == "xc"){
          that.$router.push({ path: "/" });
        }else{
          //如果是其他系统默认跳转菜单第一个页面
          let GoToPath = menus[0].path + "/" + menus[0].children[0].path;
          that.$router.push({ path: GoToPath });
        }
      });
    },
    // 查询待办数量
    fetchTodoCount() {
      GetConstructionOrderTodoCount({}).then((res) => {
        if (res.code == "200") {
          const orderTodo = this.todoList.find((item) => item.type === "order");
          if (orderTodo) {
            orderTodo.count = res.data || 0;
          }
        }
      });
    },
    // 点击待办查看
    handleTodoView(item) {
      if (!item.path) {
        return;
      }
      if (item.type === "order") {
        this.$router.push({ path: item.path, query: { state: 1 } });
      } else {
        this.$router.push({ path: item.path });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.user-info {
  position: fixed;
  top: 0;
  right: 40px;
  display: flex;
  align-items: center;
  z-index: 100;
  height: 64px;
}
.head-img {
  padding-right: 6px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.user-info-link {
  display: flex;
  align-items: center;
}
.user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.4;
}
.user-name {
  color: #595959;
  font-size: 14px;
  vertical-align: middle;
}
.tenant-tag {
  margin-top: 4px;
}
.systemTypeBtns {
  margin-right: 30px;
}
.todo-bell-wrapper {
  margin-right: 20px;
  display: flex;
  align-items: center;
}
.bell-icon-wrapper {
  line-height: 1;
  padding: 6px;
}
.bell-icon-wrapper i {
  font-size: 20px;
  color: #595959;
  cursor: pointer;
}
.todo-panel {
  padding: 8px 4px;
}
.todo-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  padding: 0 8px 10px;
  border-bottom: 1px solid #e8e8e8;
}
.todo-list {
  display: flex;
  flex-direction: column;
}
.todo-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #595959;
  padding: 10px 8px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.todo-item:last-child {
  border-bottom: none;
}
.todo-item:hover {
  background-color: #f5f5f5;
  border-radius: 4px;
}
.todo-left {
  display: flex;
  align-items: center;
}
.todo-name {
  margin-right: 8px;
}
.todo-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background-color: #ff4d4f;
  color: #fff;
  border-radius: 9px;
  font-size: 12px;
}
.todo-count-badge.zero {
  background-color: #d9d9d9;
}
.todo-view {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
  font-size: 13px;
}
.todo-view.disabled {
  color: #bfbfbf;
  cursor: not-allowed;
}
</style>
